export class PromisifyModal<T> {
	private _isOpen:boolean = false;
	public get isOpen():boolean {
		return this._isOpen;
	}

	private _onSuccess:Function = ()=>{
		return;
	};
	private _onFailure:Function = ()=>{
		return;
	};
	public get onSuccess():Function{
		return this._onSuccess;
	}
	public get onFailure():Function{
		return this._onFailure;
	}


	public async show():Promise<T>{
		if (this.isOpen) {
			throw new Error("Modal is already open");
		}
		return new Promise<T>((resolve, reject)=>{
			this._onSuccess = (args:any)=>{
				if (!this.isOpen) return;
				this._isOpen = false;
				resolve(args);
			};
			this._onFailure = (arg:any)=>{
				console.log("on failure clicked");
				if (!this.isOpen) return;
				this._isOpen = false;
				reject(arg);
			};
			this._isOpen = true;
		});
	}
}
